import React from 'react';

const TONE = {
  open: 'bg-amber-50 text-amber-700 border-amber-200',
  reviewed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  dismissed: 'bg-gray-100 text-gray-600 border-gray-200',
};

const ReportStatusBadge = ({ status, t }) => {
  const tone = TONE[status] || TONE.open;
  const label =
    status === 'reviewed' ? t('statusReviewed')
      : status === 'dismissed' ? t('statusDismissed')
      : t('statusOpen');
  return (
    <span
      data-testid={`report-status-${status}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold border ${tone}`}
    >
      {label}
    </span>
  );
};

export default ReportStatusBadge;
